import { Action, Selector, State, StateContext } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';

import Parse from 'parse';

import { UserStateModel } from './user.model';
import { InitializeUser, LogoutUser, ResetStateUser, SetCurrentUser } from './user.actions';
import { UserService } from '@core/services/user.service';

import {
  ClearOrganizations,
  LoadUserOrganizations,
  ResetStateOrganization,
} from '@stores/organizations/organizations.actions';
import { ResetStateMembers } from '@stores/members/members.actions';

const initialState: UserStateModel = {
  currentUser: null,
};

@State<UserStateModel>({
  name: 'UserState',
  defaults: initialState,
})
@Injectable()
export class UserState {
  private userService: UserService = inject(UserService);

  /* ======================================
  SELECTORS
  ====================================== */
  @Selector([UserState])
  static getCurrentUser(state: UserStateModel): Parse.User | null {
    return state.currentUser;
  }

  /* ======================================
  ACTIONS
  ====================================== */
  @Action(ResetStateUser)
  reset(context: StateContext<UserStateModel>) {
    context.setState({ ...initialState });
  }

  @Action(InitializeUser)
  async initializeUser(context: StateContext<UserStateModel>) {
    this.userService.initialize();
  }

  @Action(LogoutUser)
  logoutUser(context: StateContext<UserStateModel>) {
    context.setState({ ...initialState });
    context.dispatch(new ResetStateOrganization());
    context.dispatch(new ResetStateMembers());
  }

  @Action(SetCurrentUser)
  setCurrentUser(context: StateContext<UserStateModel>, { user }: SetCurrentUser) {
    context.patchState({
      currentUser: user,
    });

    if (user) {
      // Go load the users organizations
      context.dispatch(new LoadUserOrganizations(false));
    } else {
      // Remove all the organizations
      context.dispatch(new ResetStateOrganization());
    }
  }
}
